;(function() {
/* @ngInject */
function ZmenaSroZapisovatelController(ZmenaSroWriterSelectionService, $window) {
  let vm = this;
  let server = ZmenaSroWriterSelectionService;
  let writersLoaded = false;
  let selectedWriterLoaded = false;

  vm.writers = [];
  vm.selection = { writerId: null };
  vm.showDetail = true;
  vm.isLegaliaWriterSelection = null;
  vm.error = null;
  vm.inProgress = false;
  vm.maxStep = 2;
  vm.onBackClick = onBackClick;
  vm.onContinueClick = onContinueClick;
  vm.onWriterChange = onWriterChange;

  window.showSpinner(4);
  server.getMaxStep().then((maxStep) => {
    vm.maxStep = maxStep;
    window.hideSpinnerWhenAllResolved();
  });
  server.getWriters().then((writers) => {
    vm.writers = writers;
    writersLoaded = true;
    selectSingleWriterByDefault();
    window.hideSpinnerWhenAllResolved();
  });
  server.getSelectedWriterId().then((writerId) => {
    vm.selection.writerId = writerId;
    selectedWriterLoaded = true;
    selectSingleWriterByDefault();
    window.hideSpinnerWhenAllResolved();
  });
  server.isLegaliaWriterSelection().then((isLegaliaWriterSelection) => {
    vm.isLegaliaWriterSelection = isLegaliaWriterSelection;
    window.hideSpinnerWhenAllResolved();
  });

  function selectSingleWriterByDefault() {
    if (
      writersLoaded &&
      selectedWriterLoaded &&
      !vm.selection.writerId &&
      vm.writers.length === 1
    ) {
      vm.selection.writerId = vm.writers[0].id;
    }
  }

  function onBackClick() {
    $window.location = "krok3";
  }

  function onWriterChange() {
    vm.error = null;

    if (!vm.selection.writerId) {
      return;
    }

    server.assignNotaryWriter(vm.selection.writerId.toString()).then(({success, error}) => {
      if (!success) {
        vm.error = error;
      }
    }).catch(onRequestFailure);
  }

  function onContinueClick() {
    if (vm.inProgress) {
      return;
    }

    vm.error = null;

    if (!vm.selection.writerId) {
      vm.error = "Vyberte zapisovateľa.";
      return;
    }

    vm.inProgress = true;
    window.showSpinner(1);
    server.assignNotaryWriter(vm.selection.writerId.toString()).then(({success, error}) => {
      if (success) {
        server.finish().then(({success: finishSuccess, error: finishError}) => {
          if (finishSuccess) {
            $window.location = "objednane";
          } else {
            // TODO move backend error rendering into a shared Angular response layer.
            vm.error = finishError;
            vm.inProgress = false;
            window.hideSpinnerWhenAllResolved();
          }
        }).catch(onRequestFailure);
      } else {
        // TODO move backend error rendering into a shared Angular response layer.
        vm.error = error;
        vm.inProgress = false;
        window.hideSpinnerWhenAllResolved();
      }
    }).catch(onRequestFailure);
  }

  function onRequestFailure() {
    // TODO move backend error rendering into a shared Angular response layer.
    vm.error = "Objednávku sa nepodarilo dokončiť. Skúste to prosím znova.";
    vm.inProgress = false;
    window.hideSpinnerWhenAllResolved();
  }
}

angular.module("firmaren")
  .controller("ZmenaSroZapisovatelController", ZmenaSroZapisovatelController);
}());
